import React,{useState,useEffect,useRef} from 'react';

// reactstrap components
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Table,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";
import {CHANNELS_BY_CLIENT,DELETE_CHANNEL,PENDING_CHANNELS} from "../../constants"
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {useHistory} from "react-router-dom";
import axios from 'axios';
import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import ResponsivePagination from "react-responsive-pagination";
import ReactBSAlert from "react-bootstrap-sweetalert";
import NotificationAlert from "react-notification-alert";

const ChannelList = () => {

  const navigate = useHistory();
  const[chanldata,setChanldata] = useState([])
  const [alert, setAlert] = useState(null);
  const notificationAlertRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  let lclstrg = localStorage.getItem("user");
  let user = JSON.parse(lclstrg);

useEffect(()=>{
  getChannelList(1)
},[])

// const getChannelList=async(pageNo)=>{
//   setIsLoading(true)
//   const userObj = localStorage.getItem("user");
//   const user=JSON.parse(userObj);
//   setCurrentPage(pageNo);
//   await axios.get(CHANNELS_BY_CLIENT+ "?page=" + pageNo+"&client_id="+user.client).then(res=>{setChanldata(res?.data)
   
//     setIsLoading(false)
//   }).catch((err)=>{
    
//     let  options = {
//       place: "tr",
//       message: "Unable to fetch records",
//       type: "warning",

//       autoDismiss: 2,
//     };
//     notificationAlertRef?.current?.notificationAlert(options);
//     console.log(err)})
// }

const getChannelList=(pageNo)=>{
    
  setCurrentPage(pageNo);
  let payload = {
    page:pageNo,
    client_id:user?.client
    
     //0->Pending,1->Approve, 2-> Reject
  }
  axios.get(PENDING_CHANNELS+ "?page=" + pageNo+"&status=0"+"&client_id="+user?.client).then(res=>{setChanldata(res?.data)
    setIsLoading(false)
  }).catch((err)=>{
    let options={}
     options = {
      place: "tr",
      message: "Unable to fetch records",
      type: "warning",

      autoDismiss: 2,
    };
    notificationAlertRef?.current.notificationAlert(options);
    console.log(err)}).finally(()=>{
      setIsLoading(false)
    })
}

const confirmdelete = (id) =>{
  setAlert(<ReactBSAlert
      warning
      style={{ display: "block", marginTop: "-100px" }}
      title="Are you sure?"
      onConfirm={() => deleteChannel(id)}
      onCancel={() => setAlert(null)}
      confirmBtnBsStyle="success"
      cancelBtnBsStyle="danger"
      confirmBtnText="Yes, Delete"
      cancelBtnText="Cancel"
      showCancel
      btnSize=""
    >
        You want to remove channel ?
    </ReactBSAlert>
    );
}

const deleteChannel = (cid) => {

  setIsLoading(true)
  axios
    .post(DELETE_CHANNEL, { id:cid})
    .then((res) => {
      if(res.status==200){
        getChannelList(1);
        setIsLoading(false)
        setAlert(false)
     let options = {
        place: "tr",
        message: "Deleted Successfully",
        type: "success",

        autoDismiss: 2,
      };
      notificationAlertRef.current.notificationAlert(options);
      setIsLoading(false)
    }
    })
    .catch((e) => {
      let options = {
        place: "tr",
        message: "Unable to Delete",
        type: "warning",

        autoDismiss: 2,
      };
      notificationAlertRef?.current?.notificationAlert(options);
      setIsLoading(false)
    });
};
  return (
    <>
    <LoadingScreen
        children=""
        loading={isLoading}
        bgColor="rgba(0,0,0,0.7)"
        spinnerColor="#9ee5f8"
        textColor="#676767"
        logoSrc={logo}
        text="Loading..."
      ></LoadingScreen>
       
      <div className="content pb-0">
      {alert}
      <Row>
          <Card className="mb-0">
            <NotificationAlert ref={notificationAlertRef} />
            <CardBody className="tableheightwf">
              <Col sm="12">
              <Row>
        <Col sm="9">
                    <h4 className="">
                      <Button
                        className="btn btn-icon btn-round btn-success"
                        onClick={()=>navigate.push('/admin/channel/createchannel')}
                      >
                        <i className="tim-icons icon-simple-add"></i>
                      </Button>
                      Add Template
                    </h4>
                  </Col>
          <Col className="mb-0" md="12">
            <Card className="mb-0">
             
             
              <TableContainer component={Paper} className="">
      <Table sx={{ minWidth: 650 }} aria-label="simple table" responsive striped>
        <thead>
          <tr>
                    <th >S no </th>
                    <th > Client </th>
                    <th > Channel</th>
                    <th > Status</th>    
                    <th > Action</th>      

          </tr>
        </thead>
        <tbody>
         {
          chanldata?.data?.length>0?chanldata?.data?.map((item,index)=>
            
            <tr>
              <td>{++index}</td>
              <td>{item?.company_name}</td>
              <td>{item?.channels_type}</td>
              <td>{item?.is_approved==0?"Pending":item?.is_approved==1?"Approved":"Rejected"}</td>
              <td>
                                <a to="" className="text-info mr-2">
                                  <i
                                    className="tim-icons icon-pencil"
                                
                                      onClick={()=>navigate.push("/admin/channel/createchannel",{id:item.id})
                                     
                                    }
                                  ></i>
                                </a>
                                <a to="" className="text-warning ml-2">
                                  <i 
                                    className="tim-icons icon-trash-simple"
                                  
                                    onClick={() => confirmdelete(item.id)}
                                  ></i>
                                </a>
                              </td>
            </tr>
          ):
          <tr>
            <td colSpan={5}>No Reords Found</td>
          </tr>
         }
        </tbody>
      </Table>
    </TableContainer>
             
              {chanldata?.num_of_pages > 0 && (
              <div style={{ marginLeft: "auto", padding: "8px" }}>
                <ResponsivePagination
                  current={currentPage}
                  total={chanldata?.num_of_pages}
                  onPageChange={(newPage) => {
                    getChannelList(newPage);
                  }}
                />
              </div>
            )}
            </Card>
          </Col>
          
        </Row>
                </Col>
                </CardBody>
                </Card>
                </Row>
     
      
      

      </div>
    </>
  )
}

export default ChannelList
